import Typography from "@mui/material/Typography";
import { FC } from "react";
import CountIndicator from "shared/components/CountIndicator";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import { COLOR_BLACK, COLOR_GREY_11 } from "shared/theme/colors";
import { ExpandMoreIcon } from "shared/theme/icons/ExpandMoreIcon";
import { StyledButton } from "./styled";

type ComboTriggerProps = {
  title: string;
  count: number;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  open: boolean;
};

const ComboTrigger: FC<ComboTriggerProps> = ({
  title,
  count,
  onClick,
  open,
}) => {
  return (
    <StyledButton
      id="combo-trigger-button"
      aria-controls={open ? "combo-trigger-menu" : undefined}
      aria-haspopup="true"
      aria-expanded={open ? "true" : undefined}
      isActive={open}
      isSmallButton={false}
      onClick={onClick}
      endIcon={
        <FlexCenter columnGap={"0.5rem"}>
          {Boolean(count) ? <CountIndicator count={count} /> : null}
          <FlexCenter sx={{ transform: `rotate(${open ? 180 : 0}deg)` }}>
            <ExpandMoreIcon color={COLOR_GREY_11} />
          </FlexCenter>
        </FlexCenter>
      }
    >
      <Typography
        variant={"bodyMMedium"}
        textTransform={"capitalize"}
        color={COLOR_BLACK}
      >
        {title}
      </Typography>
    </StyledButton>
  );
};

export default ComboTrigger;
